module.exports = __webpack_public_path__ + "img/banner_tencent.5d7c9bbd.jpg";